export const notifyUser = async (message, { onClick }) => {
    if (!message || message === "") {
        return;
    }

    let notification = null;
    if (Notification.permission === "granted") {
        notification = new Notification(message);
    } else if (Notification.permission === "default") {
        const requestedPermission = await requestUserNotificacion();
        if (!requestedPermission) {
            return;
        }
        if (requestedPermission === "granted") {
            notification = new Notification(message);
        }
    }

    if (notification) {
        notification.onclick = (event) => {
            event.preventDefault();
            if (onClick) {
                onClick();
            }
            notification.close();
        };
    }

    return notification;
};

export const requestUserNotificacion = async () => {
    let permission = null;
    try {
        permission = await Notification.requestPermission();
    } catch (error) {
        console.error(error);
    }

    return permission;
};
